import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';
import { classnamePrefix } from '../../../../../constants';
import { dictionary } from '../../../../dictionary';
import { Image, Share } from '../../../common';

export const User = ({
  data: {
    pictures: { sizes },
    name,
    link: userLink
  },
  link,
  share
}) => {
  const { lang } = useSettings();

  const handleClick = () =>
    window.open(userLink, '_blank', 'noopener,noreferrer');

  return (
    <Component>
      <ImageLink role="link" onClick={handleClick}>
        <Image imagesArray={sizes} alt={name} />
      </ImageLink>

      <NameLink target="_blank" href={userLink} rel="nofollow">
        {name}
      </NameLink>

      <FollowButton onClick={handleClick}>
        + {dictionary[lang]?.['Follow'] || dictionary.en['Follow']}
      </FollowButton>

      {share && (
        <ShareContainer>
          <Share link={link} popup />
        </ShareContainer>
      )}
    </Component>
  );
};

const Component = styled.div.attrs({
  className: `${classnamePrefix}-user-component`
})`
  margin-top: 12px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(26, 46, 59, 0.1);
`;

const ImageLink = styled.div.attrs({
  className: `${classnamePrefix}-user-image`
})`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  position: relative;
  cursor: pointer;
`;

const NameLink = styled.a.attrs({
  className: `${classnamePrefix}-user-name`
})`
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: rgb(26, 46, 59);
  margin-left: 8px;
  text-overflow: ellipsis;
  overflow: hidden;
  flex-shrink: 0;
  white-space: nowrap;
`;

const FollowButton = styled.button.attrs({
  className: `${classnamePrefix}-user-follow`
})`
  font-size: 14px;
  line-height: 20px;
  color: rgb(2, 172, 239);
  margin-left: 12px;
  border: none !important;
  background: none !important;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const ShareContainer = styled.div.attrs({
  className: `${classnamePrefix}-user-share`
})`
  margin-left: auto;
  padding-left: 8px;
`;
